import { render, staticRenderFns } from "./Airpure.vue?vue&type=template&id=f1a769a2&scoped=true&"
import script from "./Airpure.vue?vue&type=script&lang=js&"
export * from "./Airpure.vue?vue&type=script&lang=js&"
import style0 from "./Airpure.vue?vue&type=style&index=0&id=f1a769a2&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1a769a2",
  null
  
)

export default component.exports